<template>
  <div>
    <div class="breadcrumb">
      <v-breadcrumb>
        <!-- <v-breadcrumb-item>
          <v-icon type="home"></v-icon>
          <a @click="() => $router.push('/student/dashboard')">Dashboard </a>
        </v-breadcrumb-item> -->
        <v-breadcrumb-item>
          <span>Schools</span>
        </v-breadcrumb-item>
      </v-breadcrumb>
    </div>

    <div class="outer-wrap">
      <div class="search-wrap schools-search-wrap">
        <v-input placeholder="Search by School Name / Campus / Province" v-model="searchStr"></v-input>
        <i class="anticon anticon-search"></i>
      </div>

      <div style="overflow-y:auto;height: calc(100vh - 174px);">
        <v-tab-pane tab-key="1" icon="global" tab="Schools / Colleges">
          <v-card-grid v-for="school in schools" :key="school.id"
            v-if="!searchStr || (searchStr && (`${school.name.toLowerCase()} ${(school.campus || '').toLowerCase()} ${school.province.toLowerCase()}`).indexOf(searchStr.toLowerCase()) > -1)">
            <div class="mask" @click="() => schoolView(school)">
              <div class="img-wrap">
                <img :src="`http://storage.googleapis.com/caned-dev.appspot.com/college-logos/${school.name.toLowerCase()}.jpg`" width="30px" />
              </div>
              <div class="school-name">{{school.name.length > 60 ? `${school.name.substring(0, 60)}...` : school.name }}</div>
              <div class="province">{{school.campus}}, {{school.province}}</div>
            </div>
          </v-card-grid>
        </v-tab-pane>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import fb from '@/firebase'

export default {
  name: 'EmployeeSchoolsView',
  data () {
    return {
      searchStr: null
    }
  },
  computed: {
    ...mapGetters([
      'schools'
    ])
  },
  watch: {
    schools: {
      handler (val) {
        if (!val) {
          this.$store.dispatch('getSchools')
        }
      },
      immediate: true
    }
  },
  methods: {
    userAction (data) {
      if (data.content === 'Logout') {
        fb.logout()
      }
    },
    schoolView (school) {
      this.$router.push(`/employee/school/${school.id}`)
    }
  }
}
</script>

<style scoped>
.outer-wrap {
  padding: 0 16px 16px 16px;
}
.breadcrumb {
  padding: 16px;
}
.ant-card-grid .mask {
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.ant-card-grid .mask .img-wrap {
  min-height: 90px;
  height: 80px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.ant-card-grid .mask img {
  width: 140px;
}
.ant-card-grid .school-name {
  font-size: 16px;
  font-weight: 600;
  color: #323a45;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align:center;
  letter-spacing:0.5px;
}
.ant-card-grid .province {
  font-size: 13px;
  color: #323a45;
  display: flex;
  align-items: center;
  justify-content: center;
}
.schools-search-wrap {
  margin-bottom: 16px;
  height: 70px;
  display: flex;
  align-items:center;
  justify-content: center;
  position:relative;
}
.schools-search-wrap i {
  position: absolute;
  right: 30px;
  font-size: 22px;
  color: rgb(216, 217, 218);
}
.schools-search-wrap input {
  font-size: 16px;
  color: #7e8890;
  padding: 16px 30px 16px 30px;
  height: 60px !important;
  width: 100%;
  border-radius:50px;
  outline:none;
}
.schools-search-wrap input:focus{
  box-shadow: 0 1px 23.28px 5.72px rgba(255,51,102,.07)
}
.ant-card-grid:hover .school-name, .ant-card-grid:hover .province {
  color:#f36;
}
</style>



// WEBPACK FOOTER //
// src/views/Employee/EmployeeSchoolsView.vue